import MapPin, { MapIconType } from '../pin/MapPin';
import { getMapPinPropsFromNumbeCode } from 'src/api/wa/store/models/workplace/OperationStatus';

function SitesIcon(reserved: boolean, statusId: string, sectionCode: string) {
  const isElecare = sectionCode === '91';

  const statusBasedProps = getMapPinPropsFromNumbeCode(statusId);

  const mapPinProps = isElecare
    ? { iconType: MapIconType.elecare, reserved, ...statusBasedProps }
    : reserved
      ? { ...statusBasedProps, dotColor: 'bg-black' }
      : statusBasedProps;

  return <MapPin {...mapPinProps} />;
}

export default SitesIcon;
